import classNames from "classnames";
import {FiUpload} from "react-icons/fi";

import {Icon} from "@/components/icon/Icon.tsx";

import styles from "./ImagePreviewLabel.module.scss";

interface ImagePreviewLabelProps {
  id?: string;
  name: string;
  previewImageUrl?: string;
  variant?: "default" | "report";
}

export const ImagePreviewLabel = ({id, name, previewImageUrl, variant = "default"}: ImagePreviewLabelProps) => {
  return (
    <label className={classNames(styles.imageContainer, styles[variant])} htmlFor={id || name}>
      {previewImageUrl ? (
        <img className={styles.inputImagePreview} src={previewImageUrl} alt={name} />
      ) : (
        <div>
          <Icon icon={FiUpload} />
        </div>
      )}
    </label>
  );
};
